<template>
  <div class="field-wrapper">
    <LabeledSelect class="sm" :placeholder="$t('app.campaign.newPage.spacePlaceholder')" name="campaign-space" option-label="name" :label="$t('app.campaign.newPage.chooseSpace.label')" v-model="model" :reduce="(space) => space.workspace_id" :clearable="false" :options="isSpacesPending ? [] : spaces">
      <template #list-footer>
        <li id="create-space" class="vs__dropdown-option" role="option" @click="state.spaceModalIsOpen = true">
          <i class="bi bi-plus-lg" />
          {{ $t("app.campaign.newPage.createSpace") }}
        </li>
      </template>
      <template v-slot:no-options="{ search, searching }">
        <div style="padding: 8px 0">{{ $t("app.campaign.newPage.noResult") }}{{ searching ? ` ${$t("app.campaign.newPage.for")} ${search}` : "" }}.</div>
      </template>
    </LabeledSelect>
  </div>
  <SpaceModal :isOpen="state.spaceModalIsOpen" action="create" @close="state.spaceModalIsOpen = false" @created="model = $event.workspace.workspace_id" />
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.field-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  .label {
    font-family: $bioSans;
    font-size: 12px;
    display: flex;
    align-items: center;
    color: var(--label-color);
  }
}
</style>

<script setup lang="ts">
import LabeledSelect from "@/components/global/LabeledSelect.vue";
import SpaceModal from "@/components/modals/app/SpaceModal.vue";

import { useSpaces } from "@/queries/space.query";
import { CampaignCreation } from '@/types/campaign';

const route = useRoute();

const { data: spaces, isPending: isSpacesPending } = useSpaces();

const state = reactive<{
  spaceModalIsOpen: boolean,
}>({
  spaceModalIsOpen: false,
});

const props = defineProps<{
  modelValue: CampaignCreation,
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: CampaignCreation): void
  (e: 'valid', value: boolean): void
}>();

const model = computed({
  get: () => props.modelValue.campaign.parent_workspace_id,
  set: (value: string) => {
    props.modelValue.campaign.parent_workspace_id = value;
    if (value.trim().length) {
      emit('valid', true);
    } else {
      emit('valid', false);
    }
    emit('update:modelValue', props.modelValue);
  }
});

</script>